import { TicketStatusEnum } from '@acme/api/admin';
import React from 'react';

export interface TicketStatusBadgeProps {
  statusId?: TicketStatusEnum | number | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const statusConfig: Record<
  TicketStatusEnum,
  { label: string; color: string; bgColor: string }
> = {
  [TicketStatusEnum.Open]: {
    label: 'Ожидает ответа',
    color: 'text-red-800',
    bgColor: 'bg-red-100',
  },
  [TicketStatusEnum.InProgress]: {
    label: 'В обработке',
    color: 'text-yellow-800',
    bgColor: 'bg-yellow-100',
  },
  [TicketStatusEnum.Closed]: {
    label: 'Закрыто',
    color: 'text-green-800',
    bgColor: 'bg-green-100',
  },
};

const sizeClasses = {
  sm: 'px-2.5 py-0.5 text-xs',
  md: 'px-3 py-1 text-sm',
  lg: 'px-4 py-1.5 text-base',
};

export const TicketStatusBadge: React.FC<TicketStatusBadgeProps> = ({
  statusId,
  size = 'md',
  className = '',
}) => {
  if (!statusId) {
    return null;
  }

  const statusInfo = statusConfig[statusId as TicketStatusEnum];

  if (!statusInfo) {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center rounded-md font-medium ${statusInfo.bgColor} ${statusInfo.color} ${sizeClasses[size]} ${className}`}
    >
      {statusInfo.label}
    </span>
  );
};
